export default __webpack_public_path__ + "static/media/img-0128-france-premium-face.f8195c88.png";